export default __webpack_public_path__ + "static/media/2086.a410a856.png";